import { Link } from '@remix-run/react'

import { Icon } from '../ui/icon'

export default function ByeNavbar({}: {}) {
	return (
		<header>
			<nav>
				<div className="flex flex-col gap-4 pt-4 md:gap-0">
					{/* Is the women men and kids and plenty icon  */}
					<div className="mx-auto flex items-center justify-center">
						<Link
							to={'/information'}
							className="flex items-center justify-center"
						>
							<Icon
								className="text-body-md h-[60px] w-[160px]"
								name="plenty"
								aria-hidden="true"
							/>
						</Link>
					</div>
				</div>
			</nav>
		</header>
	)
}
